import { connect } from 'react-redux'

import { setContentFilter } from '../actions/contentFilter'

const mapStateToProps = state => ({
  contentFilter: state.contentFilter
})

const mapDispatchToProps = dispatch => ({
  setContentFilter: (vehicle, type, id) =>
    dispatch(setContentFilter(vehicle, type, id)),
  resetContentFilter: () => dispatch(setContentFilter('', '', ''))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)



// WEBPACK FOOTER //
// ./src/hocs/withContentFilter.js